"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _index = _interopRequireDefault(require("@/layoutTop/index.vue"));
_vue.default.use(_vueRouter.default);

/* Layout */

/* Router Modules */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
var constantRoutes = exports.constantRoutes = [{
  path: '/',
  redirect: '/home'
}, {
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/common/redirect/index'));
      });
    }
  }]
},
// {
//   path: '/bookingSpace',
//   component: Layout,
//   redirect: '/bookingSpace',
//   hidden: true,
//   children: [
//     {
//       path: '/bookingSpace/bookingSpaceList',
//       component: () => import('@/views/booking/bookingSpace/bookingSpaceList.vue'),
//       name: 'Profile',
//       meta: { title: '订舱', icon: 'user', noCache: true }
//     },
//     {
//       path: '/bookingSpace/bookingSpaceMy',
//       component: () => import('@/views/booking/bookingSpace/bookingSpaceMy.vue'),
//       name: 'Profile',
//       meta: { title: '我的订舱', icon: 'user', noCache: true }
//     },
//     {
//       path: '/bookingSpace/bookingSpaceDetail',
//       component: () => import('@/views/booking/bookingSpace/components/bookingSpaceDetail.vue'),
//       name: 'Profile',
//       meta: { title: '订舱mingxi ', icon: 'user', noCache: true }
//     },

//   ]
// },
// 订舱路由
{
  path: '/topMenu',
  component: _index.default,
  redirect: '/topMenu/searchFile',
  hidden: true,
  children: [{
    path: '/topMenu/searchFile',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/infoSearch/searchFile'));
      });
    },
    name: 'searchFile',
    meta: {
      title: 'searchFile',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/cargoTrack',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/query/cargoTrack/cargoTracking'));
      });
    },
    name: 'cargoTrack',
    meta: {
      title: 'cargoTrack',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/equipmentFee',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/equipment/equipmentFee/demurrageAccountSearch'));
      });
    },
    name: 'equipmentFee',
    meta: {
      title: 'equipmentFee',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/voyagePlanSearch',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/vessel/voyagePlan/voyagePlanSearch'));
      });
    },
    name: 'voyagePlanSearch',
    meta: {
      title: 'voyagePlanSearch',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/vesselMovementSearch',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/vessel/vesselMovement/vesselMovement'));
      });
    },
    name: 'vesselMovementSearch',
    meta: {
      title: 'vesselMovementSearch',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/vesselInfo',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/vesselInfo/vesselInfo'));
      });
    },
    name: 'vesselInfo',
    meta: {
      title: 'vesselInfo',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/demurrageCalculation',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/equipment/demurrageCalculation/demurrageCalculation'));
      });
    },
    name: 'demurrageCalculation',
    meta: {
      title: 'demurrageCalculation',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/tariffs',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/equipment/demurrageTariffs/tariffs'));
      });
    },
    name: 'tariffs',
    meta: {
      title: 'tariffs',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/containerInfo',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/equipment/containerInfo/containerInfo'));
      });
    },
    name: 'containerInfo',
    meta: {
      title: 'containerInfo',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/carbonCalculator',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/query/carbonCalculator/carbonCalculator'));
      });
    },
    name: 'carbonCalculator',
    meta: {
      title: 'carbonCalculator',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/surchargeAndMiscellaneous',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/query/surchargeAndMiscellaneous/surchargeAndMiscellaneous'));
      });
    },
    name: 'surchargeAndMiscellaneous',
    meta: {
      title: 'surchargeAndMiscellaneous',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/dangerCargoSpecContainer',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/dangerCargo/dangerCargo'));
      });
    },
    name: 'dangerCargoSpecContainer',
    meta: {
      title: 'dangerCargoSpecContainer',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/release',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/doc/release/releaseInfo'));
      });
    },
    name: 'release',
    meta: {
      title: 'release',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/cargoInfoSearch',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/import/cargoInfo/cargoInfoSearch'));
      });
    },
    name: 'cargoInfoSearch',
    meta: {
      title: 'cargoInfoSearch',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/delivery',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/doc/delivery/deliveryInfo'));
      });
    },
    name: 'delivery',
    meta: {
      title: 'delivery',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/vgmApply',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/doc/vgm/vgmApply'));
      });
    },
    meta: {
      title: 'vgmApply',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/topMenu/issueApply',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/issueApply'));
      });
    },
    name: 'issueApply',
    meta: {
      title: 'issueApply',
      icon: 'user',
      noCache: true
    }
  }, {
    path: '/portContacts',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/portContacts'));
      });
    },
    hidden: true
  }, {
    path: '/helpDocuments',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/helpDocuments'));
      });
    },
    hidden: true
  }, {
    path: '/bookingSpace/ediFeedBack/sendFailureGuidebook',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/booking/bookingSpace/sendFailGuidebook'));
      });
    },
    hidden: true
  }]
}, {
  path: '/home',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/commonData/home/index'));
    });
  },
  hidden: true
}, {
  path: '/register',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/commonData/register/index'));
    });
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/commonData/home/auth-redirect'));
    });
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/common/error-page/404'));
    });
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/common/error-page/401'));
    });
  },
  hidden: true
}, {
  path: '/vipCargoTrack',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/user/vipCargo/index'));
    });
  },
  hidden: true
}, {
  path: '/bookingJapanDgList',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/booking/bookingSpace/bookingJapanDgList'));
    });
  },
  hidden: true
}, {
  path: '/containerTypeDetail',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/booking/bookingSpace/containerTypeDetail'));
    });
  },
  hidden: true
}, {
  path: '/WechatProfile',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/profile'));
    });
  }
}, {
  path: '/WechatDisclaimer',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/disclaimer'));
    });
  }
}, {
  path: '/questionnaire',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/admin/user/questionNaire'));
    });
  }
}, {
  path: '/cancelVesselPlan/:id',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/admin/cancel/cancelVesselPlan.vue'));
    });
  }
}, {
  path: '/cancelCargo/:id',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/admin/cancel/cancelCargo.vue'));
    });
  }
}, {
  path: '/searchFile',
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require('@/views/infoSearch/searchFile'));
    });
  },
  hidden: true
}, {
  path: '/profile',
  component: _layout.default,
  redirect: '/profile/index',
  hidden: true,
  children: [{
    path: '/profile/index',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/commonData/profile/index'));
      });
    },
    name: 'Profile',
    meta: {
      title: 'profile',
      icon: 'user',
      noCache: true
    }
  }]
}];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
var asyncRoutes = exports.asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    // mode: 'history', // require service support 路由模式更改
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;